<template>
    <a-row>
        <a-col span="22" >
            <div class="ant-page-header-heading" v-if="clienteName != ''">
                <span class="ant-page-header-heading-title" style="font-size: 14px;">Bienvenido {{  this.clienteName }}</span>
            </div>
            <a-breadcrumb>
                <a-breadcrumb-item><router-link :to="mytitle_link">{{ mytitle_route }}</router-link></a-breadcrumb-item>
                <a-breadcrumb-item v-if="this.$route.meta.prevMenu.length > 0" v-for="menuList in this.$route.meta.prevMenu">
                    <router-link :to="menuList.path">{{ menuList.menu }}</router-link>
                </a-breadcrumb-item>
                <a-breadcrumb-item v-if="this.$route.name != 'Dashboard'">{{ mytitle_name }}</a-breadcrumb-item>
            </a-breadcrumb>
        </a-col>
        <a-col class="show_menu" span="2">
            <!-- <a-popover title="Menú Principal" placement="bottom" trigger="hover"> -->
                <MenuUnfoldOutlined 
                    v-if="!sidebarCollapsed"
                    class="trigger"
                    :style="{ fontSize: '25px' }"
                    @click="$emit('updateCollapse', true)"
                />
                <MenuFoldOutlined 
                    v-if="sidebarCollapsed"
                    class="trigger" 
                    :style="{ fontSize: '25px' }"
                    @click="$emit('updateCollapse', false)"
                />
            <!-- </a-popover> -->
            
        </a-col>
    </a-row>
</template>
<script>
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons-vue';
export default ({
    components: {
        MenuFoldOutlined, MenuUnfoldOutlined
    },
    props: {
        sidebarCollapsed: {
            type: Boolean,
            default: false
        },
        clienteName: {
            type: String,
            default: '',
            required: false
        },
    },
    mounted() {
        // console.log(this.$route)
    },
    computed: {
        mytitle_route() {
            switch(localStorage.getItem('typeRouter')) {
                case "vendedores":
                    return (this.$route.name == 'Dashboard')  ? 'Dashboard' : 'Zona de Vendedores'
                case "coordinacion":
                    return (this.$route.name == 'Dashboard')  ? 'Dashboard' : 'Coordinación de Clientes' 
                case "construccion":
                    return (this.$route.name == 'Dashboard')  ? 'Dashboard' : 'Zona Construccion' 
                default:
                    return (this.$route.name == 'Dashboard')  ? 'Dashboard' : 'Zona de Cliente'

            }
        },
        mytitle_name() {
            if (this.$route.params && this.$route.query.tituloQuery) {
                return this.$route.query.tituloQuery
            } else {
                return this.$route.name
            }
        },
        mytitle_link() {
            if (localStorage.getItem('typeUser') !== "System") {
                return "dashboard"
            } else {
                return "dashboard_" + localStorage.getItem('typeRouter');
            }
        }
    }
})
</script>
<style lang="scss" scoped>
@use "sass:selector";
@import "../../scss/base/variables";

.show_menu {
    display: flex;
    align-items: center;

    @media ( min-width: $lg ) {
        display: none;
    }
}
.ant-page-header-heading {
    @media ( max-width: $md ) {
        display: none;
    }
    
    .ant-page-header-heading-title {
        @media ( max-width: $md ) {
            font-size: 14px !important;
        }
    }
}
</style>
